import types from '../mutation-types';
import Vue from 'vue';
import ConversationNotesAPI from '../../api/conversationNotes';
import MessageApi from '../../api/inbox/message';

const state = {
  records: {}, // { conversationId: { data: [], meta: { currentPage: 1, hasMore: false } } }
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
  },
};

const getters = {
  getAllNotesByConversation: _state => conversationId => {
    const record = _state.records[conversationId];
    const notes = record ? record.data : [];
    return notes.sort(
      (a, b) => (b.updated_at || b.created_at) - (a.updated_at || a.created_at)
    );
  },
  getMetaByConversation: _state => conversationId => {
    return _state.records[conversationId]
      ? _state.records[conversationId].meta
      : { currentPage: 1, hasMore: false };
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

const actions = {
  async get({ commit }, { conversationId, page = 1, start_date, end_date }) {
    commit(types.SET_CONVERSATION_NOTES_UI_FLAG, { isFetching: true });
    try {
      const { data } = await ConversationNotesAPI.get(conversationId, {
        page,
        start_date,
        end_date,
      });
      // A resposta da API de mensagens retorna { meta: {}, payload: [] }
      commit(types.SET_CONVERSATION_NOTES, { conversationId, data, page });
    } catch (error) {
      // Ignorar erro se não conseguir buscar
    } finally {
      commit(types.SET_CONVERSATION_NOTES_UI_FLAG, { isFetching: false });
    }
  },

  // Utiliza a action existente da store de conversations para criar mensagem privada
  async create({ dispatch }, payload) {
    const { conversationId, content, attachments } = payload;
    try {
      await dispatch(
        'conversations/createPendingMessageAndSend',
        {
          conversationId,
          content,
          private: true,
          attachments,
          status: 'sent',
        },
        { root: true }
      );
    } catch (error) {
      throw error;
    }
  },
};

const mutations = {
  [types.SET_CONVERSATION_NOTES_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },

  [types.SET_CONVERSATION_NOTES](
    $state,
    { conversationId, data: responseData, page }
  ) {
    const { meta, payload: notes } = responseData;
    // Se o meta vier com paginação, usamos. Caso contrário, inferimos pelo length.
    const hasMore =
      meta && meta.current_page
        ? meta.current_page < meta.total_pages
        : notes.length >= 10;
    const currentPage = meta && meta.current_page ? meta.current_page : page;

    if (page === 1 || !$state.records[conversationId]) {
      Vue.set($state.records, conversationId, {
        data: notes,
        meta: { currentPage, hasMore },
      });
    } else {
      const existingData = $state.records[conversationId].data;
      // Evitar duplicatas por ID
      const newNotes = notes.filter(
        note => !existingData.find(n => n.id === note.id)
      );
      Vue.set($state.records, conversationId, {
        data: [...existingData, ...newNotes],
        meta: { currentPage, hasMore },
      });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
